import type { CognitoConfig } from '@backoffice-frontend/common'
import { configureAmplify as utilsConfigureAmplify } from '@backoffice-frontend/common'
import { Environment, getEnvironment } from '@backoffice-frontend/environment'

const localCognitoPool = {
  region: 'eu-central-1',
  userPoolId: 'eu-central-1_local',
  userPoolWebClientId: 'local',
  local: true,
  domain: '',
}

const CognitoUserPools: Record<Environment, CognitoConfig> = {
  [Environment.test]: localCognitoPool,
  [Environment.local]: localCognitoPool,
  [Environment.development]: {
    region: 'eu-central-1',
    userPoolId: 'eu-central-1_T1pTVaXwM',
    userPoolWebClientId: '5a3jtd0ekdob0icf1mffp707cj',
    domain: 'moia-backoffice-saml-dev.auth.eu-central-1.amazoncognito.com',
  },
  [Environment.integration]: {
    region: 'eu-central-1',
    userPoolId: 'eu-central-1_mLvpihKIx',
    userPoolWebClientId: '3rusooc4p8ofen1sc6i9m28c8n',
    domain: 'moia-backoffice-saml-int.auth.eu-central-1.amazoncognito.com',
  },
  [Environment.production]: {
    region: 'eu-central-1',
    userPoolId: 'eu-central-1_6dXtfMPQv',
    userPoolWebClientId: '303i548r0d7rd5q2b2s9a178hj',
    domain: 'moia-backoffice-saml-prd.auth.eu-central-1.amazoncognito.com',
  },
}

export const configureAmplify = (): void => {
  const userPoolConfig = CognitoUserPools[getEnvironment()]

  utilsConfigureAmplify(userPoolConfig)
}
